import React from 'react';

const LOSE_OPTIONS = [
  { id: 'lose_0.5', label: 'Gentle', rate: '0.5 lb/week', deficit: '250 cal/day deficit', desc: 'Barely noticeable, very sustainable', color: '#6B9E8A' },
  { id: 'lose_1', label: 'Recommended', rate: '1 lb/week', deficit: '500 cal/day deficit', desc: 'Best balance of speed and sustainability', color: '#4A90D9', recommended: true },
  { id: 'lose_1.5', label: 'Aggressive', rate: '1.5 lb/week', deficit: '750 cal/day deficit', desc: 'Faster results, requires more discipline', color: '#E5A84B' },
  { id: 'lose_2', label: 'Maximum', rate: '2 lb/week', deficit: '1,000 cal/day deficit', desc: 'Maximum safe rate \u2014 not for everyone', color: '#C67A5C' },
];

const GAIN_OPTIONS = [
  { id: 'gain_lean', label: 'Lean Bulk', rate: '+250 cal/day', deficit: '', desc: 'Slow, controlled muscle gain with minimal fat', color: '#6B9E8A', recommended: true },
  { id: 'gain_standard', label: 'Standard Bulk', rate: '+500 cal/day', deficit: '', desc: 'Faster muscle gain, some fat gain expected', color: '#4A90D9' },
];

export const WeightRateStep = ({ formData, setFormData }) => {
  const options = formData.goal === 'lose_weight' ? LOSE_OPTIONS : GAIN_OPTIONS;

  return (
    <div className="space-y-3 max-w-md mx-auto">
      {options.map(opt => (
        <button
          key={opt.id}
          data-testid={`rate-${opt.id}`}
          onClick={() => setFormData(p => ({ ...p, weight_rate: opt.id }))}
          className={`w-full p-5 rounded-2xl text-left transition-all border-2 ${
            formData.weight_rate === opt.id
              ? 'border-[#1A3A4A] dark:border-[#6B9E8A] bg-[#1A3A4A]/5 dark:bg-[#6B9E8A]/10'
              : 'border-transparent bg-white/80 dark:bg-[#141C22]/80 hover:border-[#1A3A4A]/20'
          } shadow-sm relative`}
        >
          {opt.recommended && (
            <span className="absolute top-3 right-3 text-xs font-semibold px-2 py-0.5 rounded-full bg-[#6B9E8A]/15 text-[#6B9E8A]">
              Recommended
            </span>
          )}
          <div className="flex items-center gap-2 mb-1">
            <div className="w-3 h-3 rounded-full" style={{ background: opt.color }} />
            <h3 className="font-semibold text-[#1A3A4A] dark:text-[#F0EDE8]">{opt.label}</h3>
            <span className="text-sm text-[#7A7A72] ml-auto">{opt.rate}</span>
          </div>
          <p className="text-sm text-[#7A7A72] dark:text-[#A1A1AA]">{opt.desc}</p>
          {opt.deficit && <p className="text-xs text-[#7A7A72] mt-1">{opt.deficit}</p>}
        </button>
      ))}
    </div>
  );
};
